<template>
  <div class="membersOnly">
	<PageHeader class="pghead"></PageHeader>
	<PageContent class="pgcont">
		<router-view></router-view>
	</PageContent>
  </div>
</template>

<script>
  import PageHeader from '../components/organisms/PageHeader.vue'
  import PageContent from '../components/organisms/PageContent.vue'
  
  export default {
    components: {
      PageHeader,
      PageContent
    },
/*
    computed: {
		showNavMobile: function () {
			return this.$mq == 'mobile' && this.$store.state.hamburgerOpen === false ? 'invisible' : ''
		},
		showContentMobile: function () {
			return this.$mq == 'mobile' && this.$store.state.hamburgerOpen === true ? 'invisible' : ''
		}
    },
*/
    methods: {}
  }
</script>

<style src="vue-snotify/styles/material.css"></style>
<style scope>
.membersOnly {
	width:100%;
	height:100%;
}
.pghead {
	z-index: 901;
	position: relative;
	-webkit-box-shadow: 0 3px 5px -2px #aaa;
	box-shadow: 0 3px 5px -2px #aaa;
}

.pgcont {
	width: 100%;
	height: calc(100% - 75px);
}

.invisible {
	display: none;
}
</style>
